"use client"

import type React from "react"

import { Toaster } from "sonner"

interface SonnerProviderProps {
  children: React.ReactNode
}

export function SonnerProvider({ children }: SonnerProviderProps) {
  return (
    <>
      {children}
      <Toaster
        position="bottom-center"
        expand={false}
        richColors
        closeButton
        toastOptions={{
          className: "cy:font-sans cy:opacity-100",
        }}
      />
    </>
  )
}
